export default "__VITE_ASSET__MlhXUvLf__"